import { AdditionalInfoStep as SharedAdditionalInfoStep } from "../../../../../shared/additional-info/AdditionalInfoStep";
import type { AdminCombinedFormData } from "../../schema";

type BondAdditionalInfoFormData = Pick<AdminCombinedFormData, "quote">;

export const BondAdditionalInfoStep = () => (
	<SharedAdditionalInfoStep<BondAdditionalInfoFormData>
		commentPath="quote.additionalInfo.comment"
		attachmentsPath="quote.additionalInfo.attachments"
	/>
);
